export const diagnostics: Record<string, string> = {
  'Correlated mobile/server sessions, conflicts and exportable migration evidence.':
    'Mobil- és szervernaplók, ütközések és exportálható migrációs adatok.',
  'Correlation / entity': 'Kapcsolat / elem',
  'Correlation ID (optional)': 'Kapcsolatazonosító (opcionális)',
  Entity: 'Elem',
  Event: 'Esemény',
  'Export ZIP': 'ZIP exportálása',
  Fields: 'Mezők',
  GUID: 'GUID',
  'Keep mobile': 'Mobiladat megtartása',
  'Keep server': 'Szerveradat megtartása',
  Level: 'Szint',
  Lifecycle: 'Életciklus',
  'Load an organisation to view logs.': 'A naplókhoz válasszon szervezetet.',
  'Manager permission required': 'Hibajegykezelői jogosultság szükséges',
  Message: 'Üzenet',
  'No open conflicts.': 'Nincs nyitott ütközés.',
  'Open conflicts (': 'Nyitott ütközések (',
  Resolution: 'Feloldás',
  'Server sync log (': 'Szerver szinkronnaplója (',
  'Keep the mobile version?': 'Megtartja a mobilon lévő változatot?',
  'Keep the server version?': 'Megtartja a szerveren lévő változatot?',
  Load: 'Betöltés',
  'delete/update': 'törlés/módosítás',
};
